export default {"src":"/_next/static/image/public/images/flags/flag_962.bf5dcd337f26becc68c670c98910225f.svg","height":16,"width":24};